import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class CargoDetalheQuadroSalarialOxy extends Component {
  static propTypes = {
    cargo: PropTypes.object.isRequired
  };

  render() {
    const { cargo } = this.props;

    return (
      <Panel expansible={false}>
        <DisplayData border>
          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Tipo do Cargo"
              value={cargo.cargoTipo.get('descricao')}
              id="cargoTipo"
            />
            <DisplayDataItem
              sm={4}
              title="Cargo"
              value={cargo.descricao}
              id="descricao"
            />
            <DisplayDataItem
              sm={4}
              title="Quadro Salarial"
              value={cargo.quadroSalarialPath}
              id="quadroSalarialDescricao"
            />
          </DisplayDataRow>
          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Vagas total"
              value={cargo.quantidadeVagas}
              id="quantidadeVagas"
            />
            <DisplayDataItem
              sm={4}
              title="Total de Vagas Ocupadas"
              value={cargo.quantidadeVagasOcupadas}
            />
            <DisplayDataItem
              sm={4}
              title="Vagas disponíveis"
              value={cargo.quantidadeVagasDisponiveis}
              id="vagasDisponiveis"
            />
          </DisplayDataRow>
          <DisplayDataRow>
            <DisplayDataItem
              sm={12}
              title="Lei de Criação"
              value={cargo.leiCriacao}
              id="leiCriacao"
            />
          </DisplayDataRow>
        </DisplayData>
      </Panel>
    );
  }
}

export default CargoDetalheQuadroSalarialOxy;
